import React from 'react';
// import princessLogo from '../images/PrincessLogo.svg';
import useLinkTarget from '../infrastructure/isWebView/useLinkTarget';
import { getSponsorConfig } from '../helpers/sponsorConfig';

interface ISponsorLogoProperties {
  className?: string;
  type?: string;
}

const SponsorLogo = ({ className = '', type }: ISponsorLogoProperties) => {
  const target = useLinkTarget();
  const isStacked = type === 'stacked';
  const sponsorConfig = getSponsorConfig();

  if (!sponsorConfig) {
    return null;
  }

  const { logo, url, alt, track } = sponsorConfig;

  return (
    <div className={`sponsor-logo ${className} ${isStacked ? 'stacked' : ''}`}>
      <div className="sponsor-logo-label-small">Presented by</div>
      <a
        href={url}
        target={target}
        rel={target === '_blank' ? 'noreferrer noopener' : undefined}
        onClick={track}
      >
        <img src={logo} alt={alt} />
      </a>
    </div>
  );
};

export const SponsorLogoMobile = ({ classNames = '' }: { classNames?: string }) => {
  const target = useLinkTarget();
  const sponsorConfig = getSponsorConfig();

  if (!sponsorConfig) {
    return null;
  }

  const { logo, url, alt, track } = sponsorConfig;

  return (
    <div className={`sponsor-mobile ${classNames}`}>
      <p>Presented by</p>
      <a
        href={url}
        target={target}
        rel={target === '_blank' ? 'noreferrer noopener' : undefined}
        onClick={track}
      >
        <img src={logo} alt={alt} />
      </a>
    </div>
  );
};

export default SponsorLogo;
